<template>
 <div class="row" v-if="studentProgram.ProgramID">
    <div class="col-md-12">
        <div class="table-responsive p-0">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>{{$t('form.student.sr')}}</th>
                        <th>{{$t('form.student.reason')}}</th>
                        <th>{{$t('form.student.file')}}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody v-if="selectedProgramCode == 'BBA' || selectedProgramCode == 'BSC'">
                    <tr>
                        <td>1</td>
                        <td><p class="font-weight-bold">{{$t('form.student.completeCurriculumVitae')}}</p>
                        
                            <DownloadAndView :Files="studentApplication.CurriculumVitae" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="CurriculumVitae"
                            />

                        </td>
                        <td>
                            <vue-dropzone id="cvDropzone" :options="applicationDropzone" v-if="!readonly" @vdropzone-success="cvUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.CurriculumVitae" :key="index" class="d-flex justify-content-between">
                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>

                                    <a href="#" @click.prevent="removeNewApplicationFile(index,file, 'CurriculumVitae')" class="text-danger" v-if="!readonly" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>

                        <td>
                            <input v-model="studentApplicationNewData.ValidCurriculumVitae" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>2</td>
                        <td><p class="font-weight-bold">{{$t('form.student.certifiedCopyHighSchool')}} </p>
                                <DownloadAndView :Files="studentApplication.Degree" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Degree"
                            />

                        </td>
                        <td>
                            <vue-dropzone id="degreeDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="degreeUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Degree" :key="index" class="d-flex justify-content-between">
                                    <div>
                                        <span class="text-primary">{{getFileName(file)}}</span> |
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Degree')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidDegree" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>3</td>
                        <td><p class="font-weight-bold"> {{$t('form.student.officialAcademicTranscripts')}} </p>
                                <DownloadAndView :Files="studentApplication.Transcript" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Transcript"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="transcriptDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="transcriptUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Transcript" :key="index" class="d-flex justify-content-between">
                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Transcript')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidTranscript" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>4</td>
                        <td><p class="font-weight-bold">{{$t('form.student.motivationLetter')}}</p>
                        <DownloadAndView :Files="studentApplication.Letter" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Letter"
                            /></td>
                        <td>
                            <vue-dropzone id="letterDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="letterUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Letter" :key="index" class="d-flex justify-content-between">
                                    <div>



                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Letter')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidLetter" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>5</td>
                        <td><p class="font-weight-bold">{{$t('form.student.aSatScore')}}</p></td>
                        <td><input type="number" class="form-control" v-model="studentApplication.Score" required></td>
                        <td></td>
                    </tr>

                    <tr>
                        <td>6</td>
                        <td>
                            <p class="font-weight-bold">{{$t('form.student.englishProficiency')}}</p>

                                <DownloadAndView :Files="studentApplication.EnglishProficiency" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="EnglishProficiency"
                            />

                        </td>

                        <td>
                            <vue-dropzone id="pictureDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="englishProficiencyUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.EnglishProficiency" :key="index" class="d-flex justify-content-between">
                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'EnglishProficiency')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidEnglishProficiency" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>7</td>
                        <td><p class="font-weight-bold">{{$t('form.student.onePicture')}}</p>
                            <DownloadAndView :Files="studentApplication.Picture" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Picture"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="pictureDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="pictureUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Picture" :key="index" class="d-flex justify-content-between">
                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Picture')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidPicture" type="checkbox">
                        </td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td><p class="font-weight-bold">{{$t('form.student.passportCopy')}}</p>
                            <DownloadAndView :Files="studentApplication.PassportCopy" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="PassportCopy"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="passportDropzone" v-if="!readonly" :options="applicationDropzone" 
                            @vdropzone-success="passportUploaded" @vdropzone-error="uploadFileError"
                             @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>
                    
                            <ul class="p-0 mt-2">
                    
                                <li v-for="(file, index) in studentApplicationNewData.PassportCopy" :key="index" class="d-flex justify-content-between">
                                    <div v-if="file.path">
                   
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'PassportCopy')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidPassportCopy" type="checkbox">
                        </td>
                    </tr>
                    <tr>
                        <td>9</td>
                        <td><p class="font-weight-bold">{{$t('form.student.permitCopy')}}</p>
                          
                            <DownloadAndView :Files="studentApplication.PermitCopy" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="PermitCopy"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="permitDropzone" v-if="!readonly" :options="applicationDropzone" 
                            @vdropzone-success="permitUploaded" @vdropzone-error="uploadFileError"
                             @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>
                    
                            <ul class="p-0 mt-2" v-if="studentApplicationNewData.PermitCopy.length !=0">
                    
                                <li v-for="(file, index) in studentApplicationNewData.PermitCopy" :key="index" class="d-flex justify-content-between">
                                    <div>
                    
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'PermitCopy')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidPermitCopy" type="checkbox">
                        </td>
                    </tr>
                    <tr>
                        <td>10</td>
                        <td>{{$t('form.student.additionalDocument')}}
                            <DownloadAndView :Files="studentApplication.AdditionalDocuments" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="AdditionalDocuments"
                            />
                        </td>
                        <td colspan="2">
                            <vue-dropzone id="pictureDropzone" v-if="!readonly" :options="applicationDropzoneAdditionalDocument" @vdropzone-success="additionalDocumentsUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">

                                <li v-for="(file, index) in studentApplicationNewData.AdditionalDocuments" :key="index" class="d-flex justify-content-between">
                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'AdditionalDocuments')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                    </tr>

                </tbody>

                <tbody v-if="selectedProgramCode == 'AAE'">
                    <tr>
                        <td>1</td>
                        <td><p class="font-weight-bold">{{$t('form.student.completeCurriculumVitae')}}</p>
                            <DownloadAndView :Files="studentApplication.CurriculumVitae" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="CurriculumVitae"
                            />

                        </td>
                        <td>
                            <vue-dropzone id="cvDropzone" :options="applicationDropzone" v-if="!readonly" @vdropzone-success="cvUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.CurriculumVitae" :key="index" class="d-flex justify-content-between">
                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>

                                    <a href="#" @click.prevent="removeNewApplicationFile(index,file, 'CurriculumVitae')" class="text-danger" v-if="!readonly" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>

                        <td>
                            <input v-model="studentApplication.ValidCurriculumVitae" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>2</td>
                        <td><p class="font-weight-bold">{{$t('form.student.certifiedCopyHighSchool')}} </p>
                                <DownloadAndView :Files="studentApplication.Degree" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Degree"
                            />

                        </td>
                        <td>
                            <vue-dropzone id="degreeDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="degreeUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Degree" :key="index" class="d-flex justify-content-between">
                                    <div>
                                        <span class="text-primary">{{getFileName(file)}}</span> |
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Degree')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidDegree" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>3</td>
                        <td><p class="font-weight-bold"> {{$t('form.student.officialAcademicTranscripts')}} </p>
                                <DownloadAndView :Files="studentApplication.Transcript" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Transcript"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="transcriptDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="transcriptUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Transcript" :key="index" class="d-flex justify-content-between">
                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Transcript')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidTranscript" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>4</td>
                        <td><p class="font-weight-bold">{{$t('form.student.associateDegree')}}</p>
                       
                        <DownloadAndView :Files="studentApplication.AssociateDegree" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="AssociateDegree"
                            /></td>
                        <td>
                            <vue-dropzone id="letterDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="associateDegreeUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.AssociateDegree" :key="index" class="d-flex justify-content-between">
                                    <div>
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'AssociateDegree')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidAssociateDegree" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>5</td>
                        <td><p class="font-weight-bold">{{$t('form.student.aSatScore')}}</p></td>
                        <td><input type="number" class="form-control" v-model="studentApplication.Score" required></td>
                        <td></td>
                    </tr>

                    <tr>
                        <td>6</td>
                        <td>
                            <p class="font-weight-bold">{{$t('form.student.englishProficiency')}}</p>

                                <DownloadAndView :Files="studentApplication.EnglishProficiency" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="EnglishProficiency"
                            />

                        </td>

                        <td>
                            <vue-dropzone id="pictureDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="englishProficiencyUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.EnglishProficiency" :key="index" class="d-flex justify-content-between">
                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'EnglishProficiency')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidEnglishProficiency" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>7</td>
                        <td><p class="font-weight-bold">{{$t('form.student.onePicture')}}</p>
                            <DownloadAndView :Files="studentApplication.Picture" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Picture"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="pictureDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="pictureUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Picture" :key="index" class="d-flex justify-content-between">
                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Picture')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidPicture" type="checkbox">
                        </td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td><p class="font-weight-bold">{{$t('form.student.passportCopy')}}</p>
                            <DownloadAndView :Files="studentApplication.PassportCopy" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="PassportCopy"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="passportDropzone" v-if="!readonly" :options="applicationDropzone" 
                            @vdropzone-success="passportUploaded" @vdropzone-error="uploadFileError"
                             @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>
                    
                            <ul class="p-0 mt-2">
                    
                                <li v-for="(file, index) in studentApplicationNewData.PassportCopy" :key="index" class="d-flex justify-content-between">
                                    <div>
                    
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'PassportCopy')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidPassportCopy" type="checkbox">
                        </td>
                    </tr>
                    <tr>
                        <td>9</td>
                        <td><p class="font-weight-bold">{{$t('form.student.permitCopy')}}</p>
                            <DownloadAndView :Files="studentApplication.PermitCopy" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="PermitCopy"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="permitDropzone" v-if="!readonly" :options="applicationDropzone" 
                            @vdropzone-success="permitUploaded" @vdropzone-error="uploadFileError"
                             @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>
                    
                            <ul class="p-0 mt-2"  v-if="studentApplicationNewData.PermitCopy.length !=0">
                    
                                <li v-for="(file, index) in studentApplicationNewData.PermitCopy" :key="index" class="d-flex justify-content-between">
                                    <div>
                    
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'PermitCopy')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidPermitCopy" type="checkbox">
                        </td>
                    </tr>
                    <tr>
                        <td>10</td>
                        <td><p class="font-weight-bold">{{$t('form.student.additionalDocument')}}</p>
                            <DownloadAndView :Files="studentApplication.AdditionalDocuments" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="AdditionalDocuments"
                            />
                        </td>
                        <td colspan="2">
                            <vue-dropzone id="pictureDropzone" v-if="!readonly" :options="applicationDropzoneAdditionalDocument" @vdropzone-success="additionalDocumentsUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">

                                <li v-for="(file, index) in studentApplicationNewData.AdditionalDocuments" :key="index" class="d-flex justify-content-between">
                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'AdditionalDocuments')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                    </tr>

                </tbody>


                <tbody v-if="selectedProgramCode == 'MSc' || selectedProgramCode == 'MBA' || selectedProgramCode == 'EMBA'">
                    <tr>
                        <td>1</td>
                        <td><p class="font-weight-bold"> {{$t('form.student.completeCurriculumVitae')}} </p>
                            <DownloadAndView :Files="studentApplication.CurriculumVitae" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="CurriculumVitae"
                            />

                        </td>
                        <td>
                            <vue-dropzone id="cvDropzone" :options="applicationDropzone" v-if="!readonly" @vdropzone-success="cvUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.CurriculumVitae" :key="index" class="d-flex justify-content-between">
                                    
                                    <div>

                                        <a href="#" @click.prevent="downloadApplication(file.path, true)">{{getFileName(file)}}</a>
                                        |
                                        <a href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                    </div>

                                    <a href="#" @click.prevent="removeNewApplicationFile(index,file.path, 'CurriculumVitae')" class="text-danger" v-if="!readonly" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidCurriculumVitae" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>2</td>
                        <td><p class="font-weight-bold"> {{$t('form.student.certifiedCopyBachelor')}} </p>
                        <DownloadAndView :Files="studentApplication.Degree" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Degree"
                            />

                        </td>
                        <td>
                            <vue-dropzone id="degreeDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="degreeUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Degree" :key="index" class="d-flex justify-content-between">
                                    <div>
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Degree')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidDegree" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>3</td>
                        <td><p class="font-weight-bold">{{$t('form.student.officialAcademicTranscripts')}} </p>
                        <DownloadAndView :Files="studentApplication.Transcript" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Transcript"
                            />

                        </td>
                        <td>
                            <vue-dropzone id="transcriptDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="transcriptUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Transcript" :key="index" class="d-flex justify-content-between">
                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Transcript')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidTranscript" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>4</td>
                        <td><p class="font-weight-bold">{{$t('form.student.twoReferenceLetters')}}</p>
                            <DownloadAndView :Files="studentApplication.Letter" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Letter"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="letterDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="letterUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Letter" :key="index" class="d-flex justify-content-between">
                                    <div>
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Letter')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidLetter" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>5</td>
                        <td><p class="font-weight-bold">{{$t('form.student.onePicture')}}</p>

                            <DownloadAndView :Files="studentApplication.Picture" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Picture"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="pictureDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="pictureUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Picture" :key="index" class="d-flex justify-content-between">
                                    <div>                                          <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Picture')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidPicture" type="checkbox">
                        </td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td><p class="font-weight-bold">{{$t('form.student.passportCopy')}}</p>
                            <DownloadAndView :Files="studentApplication.PassportCopy" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="PassportCopy"
                            />
                        </td>
                        <td >
                            <vue-dropzone id="passportDropzone" v-if="!readonly" :options="applicationDropzone" 
                            @vdropzone-success="passportUploaded" @vdropzone-error="uploadFileError"
                             @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>
                    
                            <ul class="p-0 mt-2" v-if="studentApplicationNewData.PassportCopy.length !=0">
                    
                                <li v-for="(file, index) in studentApplicationNewData.PassportCopy" :key="index" class="d-flex justify-content-between">
                                    <div >
                    
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'PassportCopy')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidPassportCopy" type="checkbox">
                        </td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td><p class="font-weight-bold">{{$t('form.student.permitCopy')}}</p>
                            <DownloadAndView :Files="studentApplication.PermitCopy" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="PermitCopy"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="permitDropzone" v-if="!readonly" :options="applicationDropzone" 
                            @vdropzone-success="permitUploaded" @vdropzone-error="uploadFileError"
                             @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>
                    
                            <ul class="p-0 mt-2" v-if="studentApplicationNewData.PermitCopy.length !=0">
                    
                                <li v-for="(file, index) in studentApplicationNewData.PermitCopy" :key="index" class="d-flex justify-content-between">
                                    <div v-if="file">
                    
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'PermitCopy')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidPermitCopy" type="checkbox">
                        </td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td><p class="font-weight-bold">{{$t('form.student.additionalDocument')}}</p>
                        <DownloadAndView :Files="studentApplication.AdditionalDocuments" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="AdditionalDocuments"
                            />

                        </td>
                        <td colspan="2">
                            <vue-dropzone id="pictureDropzone" v-if="!readonly" :options="applicationDropzoneAdditionalDocument" 
                            @vdropzone-success="additionalDocumentsUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.AdditionalDocuments" :key="index" class="d-flex justify-content-between">
                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'AdditionalDocuments')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                    </tr>

                </tbody>

                <tbody v-if="selectedProgramCode == 'DBA'">
                    <tr>
                        <td>1</td>
                        <td>
                            <p class="font-weight-bold">{{$t('form.student.completeCurriculumVitae')}}</p>
                            <DownloadAndView :Files="studentApplication.CurriculumVitae" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="CurriculumVitae"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="cvDropzone" :options="applicationDropzone" @vdropzone-success="cvUploaded" @vdropzone-error="uploadFileError" v-if="!readonly" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.CurriculumVitae" :key="index" class="d-flex justify-content-between">

                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'CurriculumVitae')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidCurriculumVitae" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>2</td>
                        <td><p class="font-weight-bold">{{$t('form.student.certifiedCopyMaster')}} </p>
                            <DownloadAndView :Files="studentApplication.Degree" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Degree"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="degreeDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="degreeUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Degree" :key="index" class="d-flex justify-content-between">
                                    <div>


                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Degree')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidDegree" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>3</td>
                        <td><p class="font-weight-bold"> {{$t('form.student.officialAcademicTranscripts')}} </p>
                        <DownloadAndView :Files="studentApplication.Transcript" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Transcript"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="transcriptDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="transcriptUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Transcript" :key="index" class="d-flex justify-content-between">

                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Transcript')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidTranscript" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>4</td>
                        <td><p class="font-weight-bold">{{$t('form.student.employmentConfirmationLetter')}} </p>
                        <DownloadAndView :Files="studentApplication.Letter" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Letter"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="letterDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="letterUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Letter" :key="index" class="d-flex justify-content-between">
                                    <div>

                                        <span class="text-primary">{{file}}</span>
                                        |
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>

                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Letter')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidLetter" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>5</td>
                        <td><p class="font-weight-bold">{{$t('form.student.onePicture')}}</p>
                        <DownloadAndView :Files="studentApplication.Picture" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="Picture"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="pictureDropzone" v-if="!readonly" :options="applicationDropzone" @vdropzone-success="pictureUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.Picture" :key="index" class="d-flex justify-content-between">

                                    <div>



                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'Picture')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidPicture" type="checkbox">
                        </td>
                    </tr>

                    <tr>
                        <td>6</td>
                        <td>
                        <p class="font-weight-bold">{{$t('form.student.researchInterestOutline')}}</p>
                            <DownloadAndView :Files="studentApplication.ResearchInterestOutline" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="ResearchInterestOutline"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="outlineDropzone" :options="applicationDropzone" @vdropzone-success="outlineUploaded" @vdropzone-error="uploadFileError" v-if="!readonly" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">
                                <li v-for="(file, index) in studentApplicationNewData.ResearchInterestOutline" :key="index" class="d-flex justify-content-between">

                                    <div>

                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'ResearchInterestOutline')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidResearchInterestOutline" type="checkbox">
                        </td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td><p class="font-weight-bold">{{$t('form.student.passportCopy')}}</p>
                            <DownloadAndView :Files="studentApplication.PassportCopy" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="PassportCopy"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="passportDropzone" v-if="!readonly" :options="applicationDropzone" 
                            @vdropzone-success="passportUploaded" @vdropzone-error="uploadFileError"
                             @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>
                    
                            <ul class="p-0 mt-2">
                    
                                <li v-for="(file, index) in studentApplicationNewData.PassportCopy" :key="index" class="d-flex justify-content-between">
                                    <div>
                    
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'PassportCopy')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidPassportCopy" type="checkbox">
                        </td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td><p class="font-weight-bold">{{$t('form.student.permitCopy')}}</p>
                            <DownloadAndView :Files="studentApplication.PermitCopy" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="PermitCopy"
                            />
                        </td>
                        <td>
                            <vue-dropzone id="permitDropzone" v-if="!readonly" :options="applicationDropzone" 
                            @vdropzone-success="permitUploaded" @vdropzone-error="uploadFileError"
                             @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>
                    
                            <ul class="p-0 mt-2"  v-if="studentApplicationNewData.PermitCopy.length !=0">
                    
                                <li v-for="(file, index) in studentApplicationNewData.PermitCopy" :key="index" class="d-flex justify-content-between">
                                    <div>
                    
                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'PermitCopy')"
                                     class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                        <td>
                            <input v-model="studentApplication.ValidPermitCopy" type="checkbox">
                        </td>
                    </tr>
                    <tr>
                        <td>9</td>
                        <td><p class="font-weight-bold">{{$t('form.student.additionalDocument')}}</p>
                            <DownloadAndView :Files="studentApplication.AdditionalDocuments" :downloadApplication="downloadApplication"
                            :removeApplicationFile="removeApplicationFile"
                            :downloadZipApplication="downloadZipApplication"
                            :readonly="readonly"
                            Item="AdditionalDocuments"
                            />

                        </td>
                        <td colspan="2">
                            <vue-dropzone id="pictureDropzone" v-if="!readonly" :options="applicationDropzoneAdditionalDocument" @vdropzone-success="additionalDocumentsUploaded" @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true" v-on:vdropzone-sending="sendingEvent">
                            </vue-dropzone>

                            <ul class="p-0 mt-2">

                                <li v-for="(file, index) in studentApplicationNewData.AdditionalDocuments" :key="index" class="d-flex justify-content-between">
                                    <div>



                                        <a href="#" v-if="file.path" @click.prevent="downloadApplication(file.path , true)">{{getFileName(file)}}</a>
                                        <a href="#" v-else @click.prevent="downloadApplication(file , true)">{{getFileName(file)}}</a>
                                        |
                                        <a v-if="file.path" href="#" @click.prevent="downloadApplication(file.path)">{{$t('button.view')}}</a>
                                        <a v-else href="#" @click.prevent="downloadApplication(file)">{{$t('button.view')}}</a>
                                    </div>
                                    <a href="#" v-if="!readonly" @click.prevent="removeNewApplicationFile(index,file, 'AdditionalDocuments')" class="text-danger" :title="$t('form.student.remove')">X</a>
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>

            </table>
        </div>
    </div>
</div>

</template>

<script>

import vue2Dropzone from "vue2-dropzone";
import DownloadAndView from "../inc/DownloadAndView";

export default {
name:'StudentApplication',
 props: {studentApplicationNewData:Object, studentApplication:Object, studentProgram:Object,selectedProgramCode:String, applicationDropzone:Object, readonly:Boolean,passportUploaded:Function,permitUploaded:Function,cvUploaded:Function, outlineUploaded:Function , degreeUploaded:Function, associateDegreeUploaded:Function, transcriptUploaded:Function, letterUploaded:Function, englishProficiencyUploaded:Function,pictureUploaded:Function, additionalDocumentsUploaded:Function,applicationDropzonePassport:Function, applicationDropzoneAdditionalDocument:Object, downloadApplication:Function, removeNewApplicationFile:Function, removeApplicationFile:Function, downloadZipApplication:Function, getFileName:Function, sendingEvent:Function, uploadFileError:Function },

components: {
      vueDropzone: vue2Dropzone,
      DownloadAndView:DownloadAndView

    },
}
</script>
